import React, { useEffect, useState } from "react";

import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import constants from "@/utils/constants";
import getSafariVersion from "@/utils/getSafariVersion";

const Layout = loadable(() => import("@/common/Layout"));

RetoolLoader.propTypes = {
  pageTitle: PropTypes.string,
  retoolUrl: PropTypes.string,
  report: PropTypes.bool,
  useTitle: PropTypes.bool,
};

export default function RetoolLoader({
  pageTitle,
  retoolUrl,
  report,
  useTitle,
}) {
  const [prevRetoolUrl, setRetoolUrl] = useState(retoolUrl); // Track previous scope
  const [isNotSupportedIOS, setIsNotSupportedIOS] = useState(false);

  useEffect(() => {
    if (prevRetoolUrl !== retoolUrl) {
      setRetoolUrl(retoolUrl); // Update previous scope
    }
  }, [retoolUrl, prevRetoolUrl]);

  const { t } = useTranslation();

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const safariVersion = getSafariVersion(userAgent);

    setIsNotSupportedIOS(safariVersion && safariVersion <= 15);
  }, []);

  return (
    <Layout
      pageTitle={`${report ? "Reports: " : ""}${
        useTitle ? pageTitle : t(pageTitle)
      }`}
      fullScreen={true}
    >
      {/* Conditional rendering for the notice */}
      {isNotSupportedIOS ? (
        <div className={`m-4 p-4 rounded-md bg-yellow-50`}>
          <div className="flex">
            <div className="flex-shrink-0">
              <ExclamationTriangleIcon
                className={`w-5 h-5 text-yellow-400`}
                aria-hidden="true"
              />
            </div>
            <div className="ml-3">
              <h3 className={`text-sm font-medium text-yellow-800`}>
                {t(`salesReport.errors.ios.header`)}
              </h3>
              <div className={`mt-2 text-sm text-yellow-700`}>
                <p>{t(`salesReport.errors.ios.description`)}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-grow h-full relative">
          <iframe
            src={`${retoolUrl}#accessToken=${encodeURIComponent(
              localStorage.getItem(constants.ACCESS_TOKEN),
            )}&merchantId=${localStorage.getItem(
              constants.X_MERCHANT_ID,
            )}&outletId=${localStorage.getItem(
              constants.X_OUTLET_ID,
            )}&apiUrl=${encodeURIComponent(
              import.meta.env.VITE_ACCOUNT_GRAPH_URL,
            )}`}
            width="100%"
            height="100%"
            className="flex flex-grow"
          />
        </div>
      )}
    </Layout>
  );
}
